<div [ngClass]="{'container': type === 'left'}">
  <p>{{label}}</p>
  <div class="toggle-container">
    <p [ngClass]="{'active': !val}">{{firstValueLabel}}</p>
    <mat-slide-toggle [disabled]=disabled (change)="changeValue($event)" [checked]="val"></mat-slide-toggle>
    <p [ngClass]="{'active': val}">{{secondValueLabel}}</p>
  </div>
</div>